import update from 'immutability-helper';
import httpStatus from 'http-status';
import reduceReducers from 'reduce-reducers';
import _ from 'lodash';

import I18n from 'app/common/i18n';
import {history} from 'store';
import * as routePath from 'app/utils/routePath';
import {formatErrorMessage} from 'app/utils/error';
import * as cookie from 'app/utils/cookie';
import {_logoutUser} from './login';
import {fetchAssessments} from './sessions';
import {fetchReport} from './reports';
import {entitiesCount, recentEntities} from 'app/client/api';
import {fetchAssessmentsPurchaseList, fetchEntitiesCount, fetchRecentEntities} from './entity';

const initialState = {
  initialized: false,
  isBusy: false,
  error: null
}

const INITIALIZE = 'app/INITIALIZE';
const SHOW_BUSY = 'app/SHOW_BUSY';
const SHOW_APP_ERROR = 'app/SHOW_APP_ERROR';

export function loadApp() {

  return dispatch => {
    dispatch(fetchAssessments());
    dispatch(fetchAssessmentsPurchaseList());
    dispatch(initializeApp(true));
  }

}

function handleUserUnAuthorizationStatus(dispatch) {
  cookie.remove(cookie.KEY_LOGIN_TOKEN);
  dispatch(_logoutUser());
  history.push(routePath.rootRoute);
}

export function initializeApp(initialized) {
  return { type: INITIALIZE , payload: initialized}
}

export function showAppBusy(show) {
  return { type: SHOW_BUSY, payload: show }
}

export function showAppError(errorInfo) {
  return { type: SHOW_APP_ERROR, payload: errorInfo }
}

export function handleAppError(error, title, stateErrorHandler=null) {

  return dispatch => {
    let _error = error.response

    if (_error && _error.status === httpStatus.UNAUTHORIZED) {
      handleUserUnAuthorizationStatus(dispatch);
      return;
    } 
    else if(_.isError(error) && _error && _.isFunction(stateErrorHandler)) {
      stateErrorHandler(_error);
      return;
    }

    let errorInfo = {
      title: title,
      message: !_error ? I18n.t('errors.service_unavailable') : formatErrorMessage(_error, I18n.t('errors.unexpected'))
    };

    dispatch(showAppError(errorInfo));
  }
}

function reducer(state = initialState, action) {
	let { type, payload } = action;
  
	switch(type)	{

    case SHOW_BUSY:
      return update(state, { isBusy: { $set: payload } });

    case INITIALIZE:
      return update(state, { initialized: { $set: payload } });

    case SHOW_APP_ERROR:
      return update(state, { error: { $set: payload } });

		default:
			return state;
	}
}

export default reduceReducers(
  reducer,
  // validator,
)



// WEBPACK FOOTER //
// ./src/reducers/app.js